let waterMeters = {
  name: "Водомери",
  path: "/#/water_meters/list",
  target: true,
  meta: { icon_fa: "fas fa-tachometer-alt" },
  groups: ["TestMainGroup", "TestDummyGroup"],
}

export default waterMeters;